import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import EditBlogDetailsManagement from '../../../components/siteadmin/EditBlogDetails/EditBlogDetails';
import Loader from '../../../components/Loader/Loader';
import editBlogDetails from './editBlogDetails.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import s from './EditBlogDetails.css';

const EditBlogDetails = (props) => {
    const { editBlogDetailsData, title } = props;

    if (editBlogDetailsData?.loading) return <div><Loader type={"text"} /></div>;

    const blog = editBlogDetailsData?.editBlogDetails;

    const initialValues = blog ? {
        ...blog,
        dynamicBlogDetails: blog.dynamicBlogDetails?.length > 0
            ? blog.dynamicBlogDetails.map(d => ({
                language: d.language || 'en',
                metaTitle: d.metaTitle || '',
                metaDescription: d.metaDescription || '',
                pageTitle: d.pageTitle || '',
                content: d.content || ''
            }))
            : [{ language: 'en', metaTitle: blog.metaTitle || '', metaDescription: blog.metaDescription || '', pageTitle: blog.pageTitle || '', content: blog.content || '' }]
    } : {};

    return (
        <EditBlogDetailsManagement
            title={title}
            initialValues={initialValues}
        />
    );
};

EditBlogDetails.propTypes = {
    title: PropTypes.string.isRequired,
    blogId: PropTypes.number.isRequired,
    editBlogDetailsData: PropTypes.shape({
        loading: PropTypes.bool,
        editBlogDetails: PropTypes.object
    }),
};

export default compose(
    withStyles(s),
    withQuery(editBlogDetails, {
        name: 'editBlogDetailsData',
        options: (props) => ({
            variables: { id: props.blogId },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditBlogDetails);